import { type ScanEventHandler } from '../types/scanEventProcessor.type';

/**
 * Placeholder for the Scan Action Handler, logging the enriched event so scans can
 * be verified locally. The processor owns normalization and enrichment only; action
 * matching, navigation, requests and UI updates arrive with the handler itself in a
 * follow-up ticket. QPACK-459
 */
export const handleScanEvent: ScanEventHandler = (scanEvent) => {
  // eslint-disable-next-line no-console
  console.debug('[scan-events] Scan Action Handler Reached', scanEvent);
};
